// src/pages/Dashboard/components/KpiGrid.jsx
import React, { memo } from "react";

function KpiGrid({ kpis, formatter }) {
  return (
    <div className="sd-kpi-grid">
      {kpis.map((kpi) => (
        <div className="sd-kpi-card" key={kpi.label}>
          <h3>{formatter.format(kpi.value || 0)}</h3>
          <p>{kpi.label}</p>
        </div>
      ))}
    </div>
  );
}

export default memo(KpiGrid);
